export const CREW_DESCRIPTION_MAX_LENGTH = 200;
export const LINKUP_DESCRIPTION_MAX_LENGTH = 200;
export const POST_CONTENT_MAX_LENGTH = 500;
export const LISTING_MESSAGE_MAX_LENGTH = 500;
export const SEAT_FIELD_MAX_LENGTH = 20;
export const REVIEW_CONTENT_MAX_LENGTH = 1000;
export const DIRECT_MESSAGE_MAX_LENGTH = 2000;
export const PLATFORM_PRICE_MAX_SUBUNITS = 500000;
export const PLATFORM_PRICE_MAX_DOLLARS = 5000;

export const limitText = (value, maxLength) => {
  const text = value == null ? '' : String(value);
  return text.length > maxLength ? text.slice(0, maxLength) : text;
};
